__turbopack_context__.v({
  "facadeButton": "FacadeVideo-module__ZypUZa__facadeButton",
  "frame": "FacadeVideo-module__ZypUZa__frame",
  "playBadge": "FacadeVideo-module__ZypUZa__playBadge",
  "poster": "FacadeVideo-module__ZypUZa__poster",
  "root": "FacadeVideo-module__ZypUZa__root",
  "scrim": "FacadeVideo-module__ZypUZa__scrim",
  "transcript": "FacadeVideo-module__ZypUZa__transcript",
  "transcriptBody": "FacadeVideo-module__ZypUZa__transcriptBody",
  "transcriptSummary": "FacadeVideo-module__ZypUZa__transcriptSummary",
  "video": "FacadeVideo-module__ZypUZa__video",
});
